import React from "react"
import FeatureDivider from "../components/featureDivider"

const H1 = ({ header, textAlignment }) => (
  <section className={`page-h1 container px-5 py-4 ${textAlignment === "center" ? "has-text-centered" : ""}`}>
    <h1 className="is-size-3 is-size-4-mobile my-4 has-text-danger is-uppercase">{ header }</h1>
    <FeatureDivider/>
  </section>
)

export default H1